import React from 'react';
import TranslatedText from '../../../../components/atoms/translated_text';
import BaseModal from '../../../../components/molecules/base_modal';
import { ModalIDs } from '../../../../redux/reducers/gl_modal_reducer/types';

export default function RegistrationReceivedViewModal() {
  return (
    <BaseModal
      modalID={ModalIDs.MODAL_REGISTRATION_RECEIVED_VIEW}
      renderHeader={({ header, body }: IModalProps) => (
        <RegistrationReceivedViewHeader header={header} body={body} />
      )}
      renderContent={({ header, body }: IModalProps) => (
        <React.Fragment>
          <RegistrationReceivedViewBody header={header} body={body} />
        </React.Fragment>
      )}
    />
  );
}

interface IModalProps {
  header: string;
  body: string;
}

const RegistrationReceivedViewHeader = ({ header, body }: IModalProps) => {
  return <TranslatedText defaultText={header} />;
};

const RegistrationReceivedViewBody = ({ header, body }: IModalProps) => {
  return <pre>{body}</pre>;
};
